import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useRequestsBankOpsFilterFields } from './hooks/useRequestsBankOpsFilterFields';

export const RequestsBankOpsListFilterForm: React.FC = () => {
  const fields = useRequestsBankOpsFilterFields();

  return <FilterFields fields={fields} />;
};
